import { ReactNode } from "react";

import { css } from "@compiled/react";
import { useInView } from "react-intersection-observer";
import { FormattedMessage, useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";
import UFOSegment from "@atlassian/wac-ufo-segment";

import { Adg4Button } from "@/components/adg4/button/src";
import { Adg4TextUnderline } from "@/components/adg4/text-underline/src";
import { Picture } from "@/components/wpl/image/src";
import { Row } from "@/libraries/wpl/foundations/src/grid";

const CtaStyles = css({
    "margin": `${token("space.600")} 0`,
    ".polygon": {
        background: "#101214",
        clipPath:
            "polygon(1.5% 0, 70% 3%, 70% 13%, 97% 9%, 97.5% 89%, 40% 100%, 39.9% 90%, 1% 88%)",
        padding: `${token("space.1000")} 0`
    },
    ".cta": {
        "h3, p": {
            color: "#fff"
        },
        "textAlign": "center"
    },
    "&.is-visible": {}
});

export const GetStartedCTA = () => {
    const { ref: scrollRef, inView: sectionIsVisible } = useInView();
    const intl = useIntl();

    return (
        <UFOSegment name="homepage-get-started-cta">
            <section
                css={CtaStyles}
                ref={scrollRef}
                className={sectionIsVisible ? "is-visible" : ""}
                id="get-started-cta"
            >
                <div className="polygon">
                    <Row layout="8">
                        <div className="cta">
                            <h3>
                                <FormattedMessage
                                    id="HomePageTemplateV2.getStartedCtaHeader"
                                    defaultMessage="Unleash the <powerOfTeamwork>power of teamwork</powerOfTeamwork>"
                                    values={{
                                        powerOfTeamwork: (str: ReactNode) => (
                                            <Adg4TextUnderline
                                                underline={
                                                    <Picture
                                                        image={{
                                                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/power-of-teamwork-stroke.svg",
                                                            alt: ""
                                                        }}
                                                    />
                                                }
                                            >
                                                {str}
                                            </Adg4TextUnderline>
                                        )
                                    }}
                                />
                            </h3>
                            <p className=".body-lg">
                                {intl.formatMessage({
                                    id: "HomePageTemplateV2.getStartedCtaParagraph",
                                    defaultMessage:
                                        "Join millions teaming up on their best work"
                                })}
                            </p>
                            <Adg4Button variant="secondary" color="white">
                                {intl.formatMessage({
                                    id: "HomePageTemplateV2.getStartedCtaButton",
                                    defaultMessage: "Get started for free"
                                })}
                            </Adg4Button>
                        </div>
                    </Row>
                </div>
            </section>
        </UFOSegment>
    );
};
